/* iceberg-ui */
import { Box, Button } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Paper } from '@mui/material';

/*  Shared  */
import { Route } from 'application/Shared/Helpers';
import { ReportParams } from 'application/Shared/types/reports';

/*  React  */
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

/* Components */
import { ReportBuilder } from './ReportBuilder';
import { getDefaultReportConfiguration } from './helpers';
import { ReportPageHeader } from './internal/ReportPageHeader';

export const ReportsSetup = () => {
    const { t } = useTranslation();
    const { clientId, partnerId, reportType } = useParams();
    const defaultReportConfiguration = useMemo(
        () =>
            getDefaultReportConfiguration({
                clientId,
                reportType: reportType!
            }),
        [clientId, reportType]
    );
    const [reportParams, setReportParams] = useState<ReportParams>(
        defaultReportConfiguration
    );

    const stringifiedReportParams = JSON.stringify(reportParams);

    if (!reportType) {
        return null;
    }

    const baseReportsRoute = Route.buildBaseReportsRoute({
        clientId,
        partnerId
    });

    const runReportRoute = `${baseReportsRoute}/${reportType}/summary?reportParams=${stringifiedReportParams}`;

    return (
        <Box
            sx={{ '@media print': { padding: '0px !important' } }}
            data-trackid="reportSetup"
        >
            <ReportPageHeader setupReportView showActions={false} />
            <Paper
                elevation={0}
                variant="outlined"
                data-trackid="userSetsUpReportParams"
            >
                <ReportBuilder
                    reportParams={reportParams}
                    setReportParams={setReportParams}
                />
                <Box mb="8px">
                    <hr />
                    <Link to={runReportRoute}>
                        <Button
                            data-trackid="reports_userSetsUpReportParams_runReport"
                            disabled={!reportType || !reportParams.endTime}
                        >
                            {t('Reports.run_report')}
                        </Button>
                    </Link>
                </Box>
            </Paper>
        </Box>
    );
};
